import React, { Component } from "react";
import { Modal, ModalBody, Input, Button, Label, Col } from "reactstrap";
import SmsRoutingModal from "./SmsRoutingModal";
import "./enterprise-setting.css";
import Select from "react-select";
import find from "lodash/find";
import { connect } from "react-redux";
import Toggle from "react-toggle";
import OoPopover from "../../../components/UI/Popover/OoPopover";
import EnterpriseQrCode from "../../../components/UI/EnterpriseQrCode";
import MappedIcon from "./../../../assets/office_created_icon.svg";
import { QRCodeCanvas } from 'qrcode.react';
import axios from "../../../axios";
import * as url from "./../../../utils/url";
import {
  baseUrl,
  isTrivvyUrl,
  ooStandardColor,
  staticTitles,
  trivvyStandardColor,
  validateSlackUrl,
} from "./../../../utils/constants.js";
import * as actionCreators from "./../../../modules/actions/index";
import EmailList from "./EmailList";
import Papa from "papaparse";
import Spinner from "../../../assets/spinner.gif";
import { filterToolFocus } from "../../../utils/filterToolData";
import { toastContainer, dismissToast } from "../../../utils/toast";

import moment from "moment";
import { data } from "jquery";
import { MdEmail, MdOutlineMailOutline } from "react-icons/md";
import { BiLogoMicrosoftTeams, BiLogoSlack } from "react-icons/bi";
import AllowedWorkspacesComp from "./AllowedWorkspacesComp";
import EmailDomainsPopup from "./EmailDomainsPopup";
import { isBoolean } from "lodash";

// import { validateEmail } from '../../../utils/validations';

class EnterpriseSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEditEnterpriseModal: false,
      industryId: null,
      enterpriseName: "",
      alertMsg: "",
      imageError: null,
      logo:
        this.props.user.profile.organizationId.whiteLabel &&
          this.props.user.profile.organizationId.whiteLabel.logo &&
          this.props.user.profile.organizationId.whiteLabel.logo.name
          ? this.props.user.profile.organizationId.whiteLabel.logo
          : "",
      logoUrl:
        this.props.user.profile.organizationId.whiteLabel &&
          this.props.user.profile.organizationId.whiteLabel.logo &&
          this.props.user.profile.organizationId.whiteLabel.logo.url.length > 0
          ? this.props.user.profile.organizationId.whiteLabel.logo.url
          : "",
      brandColor:
        this.props.user.profile.organizationId.whiteLabel &&
          this.props.user.profile.organizationId.whiteLabel.brandColor &&
          this.props.user.profile.organizationId.whiteLabel.brandColor.length > 0
          ? this.props.user.profile.organizationId.whiteLabel.brandColor
          : "",

      o_bC:
        this.props.user.profile.organizationId.whiteLabel &&
          this.props.user.profile.organizationId.whiteLabel.brandColor &&
          this.props.user.profile.organizationId.whiteLabel.brandColor.length > 0
          ? this.props.user.profile.organizationId.whiteLabel.brandColor
          : "",

      whiteLabelName: "",

      isWhiteLabel: false,

      simpleEmailBranding:
        this.props.user.profile.organizationId.whiteLabel &&
          this.props.user.profile.organizationId.whiteLabel.simpleEmailBranding
          ? this.props.user.profile.organizationId.whiteLabel
            .simpleEmailBranding
          : false,

      emailColumn: {},
      customEmailObject: {},
      csvValues: null,
      emailFieldOptions: [],
      inActiveSaveList: false,
      isEmailList: false,
      isPlanning:
        this.props.user.profile.organizationId.isPlanning &&
          (!this.props.user.profile.organizationId.isPlanning.hasOwnProperty(
            "isDisplayed"
          ) ||
            this.props.user.profile.organizationId.isPlanning.isDisplayed)
          ? true
          : false,
      isToolkit:
        this.props.user.profile.organizationId.isToolkit &&
          (!this.props.user.profile.organizationId.isToolkit.hasOwnProperty(
            "isDisplayed"
          ) ||
            this.props.user.profile.organizationId.isToolkit.isDisplayed)
          ? true
          : false,
      isCultureApp:
        this.props.user.profile.organizationId.isCultureApp &&
          (!this.props.user.profile.organizationId.isCultureApp.hasOwnProperty(
            "isDisplayed"
          ) ||
            this.props.user.profile.organizationId.isCultureApp.isDisplayed)
          ? true
          : false,
      isAnalytics:
        this.props.user.profile.organizationId.isAnalytics &&
          (!this.props.user.profile.organizationId.isAnalytics.hasOwnProperty(
            "isDisplayed"
          ) ||
            this.props.user.profile.organizationId.isAnalytics.isDisplayed)
          ? true
          : false,
      isGroups:
        this.props.user.profile.organizationId.isGroups &&
          (!this.props.user.profile.organizationId.isGroups.hasOwnProperty(
            "isDisplayed"
          ) ||
            this.props.user.profile.organizationId.isGroups.isDisplayed)
          ? true
          : false,
      isDiversityCalendar:
        this.props.user.profile.organizationId.isDiversityCalendar &&
          (!this.props.user.profile.organizationId.isDiversityCalendar.hasOwnProperty(
            "isDisplayed"
          ) ||
            this.props.user.profile.organizationId.isDiversityCalendar
              .isDisplayed)
          ? true
          : false,
      isDEIMaturityModel:
        this.props.user.profile.organizationId.isDEIMaturityModel &&
          (!this.props.user.profile.organizationId.isDEIMaturityModel.hasOwnProperty(
            "isDisplayed"
          ) ||
            this.props.user.profile.organizationId.isDEIMaturityModel
              .isDisplayed)
          ? true
          : false,
      enterpriseRule: {
        value: "",
        error: false,
      },
      color: null,
      error: "",
      file: {
        value: this.props.file,
        error: false,
        errorMessage: "",
      },
      fileType: [
        { value: null, label: "Please select an option", disabled: true },
        { value: "Employee", label: "Employee", disabled: false },
        { value: "ATS", label: "Applicant", disabled: false },
      ],
      selectedType: "",
      error: false,
      errorMsg: "Please select a file type",
      fileTypeDefinition: false,
      currentEnterpriseRule:
        this.props.user.profile.organizationId &&
          this.props.user.profile.organizationId.emailDomains
          ? this.props.user.profile.organizationId.emailDomains
          : this.props.user.profile.organizationId.data
            ? this.props.user.profile.organizationId.data.emailDomains
            : [],

      diversityFocusOptions: [],
      selectedReourceRestrictions:
        (this.props.user.profile.organizationId &&
          this.props.user.profile.organizationId.isToolkit &&
          this.props.user.profile.organizationId.isToolkit.restrictions) ||
        [],
      allowedSlackWorkspaces:
        this.props.user.profile.organizationId &&
          this.props.user.profile.organizationId.allowedSlackWorkspaces
          ? this.props.user.profile.organizationId.allowedSlackWorkspaces
          : [] || [],

      slackUrlRule: {
        value: "",
        error: false,
      },
      teamTenantRule: {
        value: "",
        error: false,
        name: "",
      },

      allowedTeamsTenants:
        this.props.user.profile.organizationId &&
          this.props.user.profile.organizationId.allowedTeamsTenants
          ? this.props.user.profile.organizationId.allowedTeamsTenants
          : [] || [],

      slackPopupOpen: { open: false },
      slackOrgPopupOpen: { open: false },
      teamsPopupOpen: { open: false },
      domainsPopupOpen: { open: false },
      domainsPopupOpen: { open: false },
      smsRoutingConfigured: !!(this.props.user.profile.organizationId && this.props.user.profile.organizationId.smsRoutingConfigured),
      smsPhoneNumber: '(555) 012-3456',
      smsFirstName: '',
      smsLastName: '',
    };
  }

  componentDidMount() {
    let orgId = this.props.user.profile.organizationId._id;
    let that = this;
    axios
      .all([axios.get(url.getMailer(orgId)), axios.get(url.findOrgById(orgId))])
      .then(
        axios.spread(function (mailer, org) {
          let mailer_item = mailer.data.data;
          let u_org = org.data.data;

          that.props.orgChangeSuccess(u_org);

          if (mailer_item && mailer_item[0]) {
            let result = mailer_item[0];
            let { fileName, createdOn } = result;
            let customEmailObject = {
              fileName,
              createdOn,
            };
            that.setState({ customEmailObject });
          }
        })
      );

    this.setState({
      enterpriseName: this.props.enterpriseInformation.name,
    });

    this.setUpFocusList();
  }

  storeRestrictions = (restrictions) => {
    const orgData = this.props.user.profile.organizationId;
    this.props.orgChangeSuccess({
      ...orgData,
      isToolkit: {
        ...orgData.isToolkit,
        restrictions: restrictions,
      },
    });
  };

  //Uncomment this when api implemented for restrictions
  //componentWillReceiveProps(nextProps) {
  //  if (
  //    JSON.stringify(this.props.user.profile.organizationId) !==
  //    JSON.stringify(nextProps.user.profile.organizationId)
  //  ) {
  //    console.log("YEAH", nextProps.user.profile.organizationId.isToolkit);
  //    this.setState({
  //      selectedReourceRestrictions:
  //        (nextProps.user.profile.organizationId &&
  //          nextProps.user.profile.organizationId.isToolkit &&
  //          nextProps.user.profile.organizationId.isToolkit.restrictions) ||
  //        [],
  //    });
  //  }
  //}

  setUpFocusList = () => {
    axios
      .get(url.getAllFoucsList)
      .then((response) => {
        // console.log(response)
        let { diversityFocusOptions, relevantForOptions } = filterToolFocus(
          response.data
        );
        diversityFocusOptions = diversityFocusOptions.filter(
          (e) => e.focus != "All"
        );
        this.setState({ diversityFocusOptions });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  toggleEditEnterpriseModal = () => {
    this.setState((prev) => ({
      showEditEnterpriseModal: !prev.showEditEnterpriseModal,
      enterpriseName: this.props.enterpriseInformation.name,
      industryId: null
    }));
  };



  hasExistingMapping = (type) => {
    const { existingMapping } = this.props;
    return (
      existingMapping &&
      existingMapping[type] &&
      existingMapping[type].data &&
      existingMapping[type].data.length > 0
    );
  };

  handleIndustryChange = (industry) => {
    this.setState({ industryId: industry });
  };

  handleEnterpriseNameChange = (e) => {
    const value = e.target.value;
    const minLength = 1;
    const maxLength = 500;

    if (
      value.length >= minLength &&
      value.length <= maxLength &&
      /^[a-zA-Z0-9\s]+$/.test(value)
    ) {
      this.setState({
        enterpriseName: value,
      });
    } else {
      this.setState({
        enterpriseName: "",
      });
    }
  };

  removeOrgEmail = (e) => {
    let arr = this.state.currentEnterpriseRule;
    let idx = arr.indexOf(e);
    arr.splice(idx, 1);
    this.setState({ currentEnterpriseRule: [...arr] });
    this.props.removeOrgEmail(arr);
  };
  removeWorkspaceUrl = (e) => {
    console.log(e);
    let arr = [...this.state.allowedSlackWorkspaces];
    let idx = arr.findIndex((x) => x.workspaceId === e.workspaceId);
    arr.splice(idx, 1);
    this.setState({ allowedSlackWorkspaces: [...arr] });
    this.props.removeOrgSlackUrl(arr, e.workspaceId);
  };
  removeTeamsTenantId = (e) => {
    console.log(e);
    let arr = this.state.allowedTeamsTenants;
    let idx = arr.findIndex((x) => x.workspaceId === e.workspaceId);
    arr.splice(idx, 1);
    this.setState({ allowedTeamsTenants: [...arr] });
    this.props.removeOrgTeamsTenant(arr, e.workspaceId);
  };
  goToInviteOfficeMates = () => {
    // console.log(this.props.history)
    // this.props.history.push('/home/office/invite-office-mates');
    this.props.history.push("/home/users/invite");
  };

  handleAddRule = () => {
    let { enterpriseRule, currentEnterpriseRule } = this.state;
    // const isValidEmail = validateEmail(enterpriseRule.value);

    this.setState({
      enterpriseRule: {
        error: false,
      },
      error: "",
    });

    // console.log(enterpriseRule)
    let value = enterpriseRule.value;

    if (value.replace(/\s/g, "").length === 0) {
      this.setState({
        enterpriseRule: {
          value: enterpriseRule.value,
          error: true,
        },
      });
    } else if (value.split(".").length < 2) {
      this.setState({
        enterpriseRule: {
          value: enterpriseRule.value,
          error: true,
        },
      });
    } else {
      let { value } = enterpriseRule;
      // this.props.handleOrgEmail(enterpriseRule.value)
      let orgId = this.props.user.profile.organizationId._id;

      if (currentEnterpriseRule.indexOf(value) === -1) {
        axios
          .post(url.addOrgEmailRule, { email: value, orgId })
          .then(({ data }) => {
            console.log(data, "----", data.data);

            if (data && data.data) {
              // console.log('success')
              this.props.orgChangeSuccess(data.data);
              let emails = data.data.emailDomains;
              this.setState((prevState) => ({
                currentEnterpriseRule: [...emails],
                enterpriseRule: { value: "", error: false },
                error: "",
              }));
            }

            // if(data.meta && !data.meta.success){
            //   this.setState({
            //     enterpriseRule: {value, error:true},
            //     error: "This email already exists."
            //   })
            // } else {
            //   console.log(data, data.data, this.props)
            //   this.props.orgChangeSuccess(data.data)
            //   this.setState((prevState) => ({
            //     currentEnterpriseRule: [...this.props.emailDomains],
            //     enterpriseRule: {value:"", error:false},
            //     error: ""
            //   }))
            // }
          })
          .catch(function (err) {
            console.log(err);
            this.emailError(value);
          });
      } else {
        this.setState({
          enterpriseRule: {
            value: enterpriseRule.value,
            error: true,
          },
          error: "This email already exists.",
        });
      }
    }
  };

  handleAddDomain = (value) => {
    return new Promise((resolve, reject) => {
      let orgId = this.props.user.profile.organizationId._id;

      axios
        .post(url.addOrgEmailRule, { email: value, orgId })
        .then(({ data }) => {
          console.log(data, "----", data.data);

          if (data && data.data) {
            this.props.orgChangeSuccess(data.data);
            let emails = data.data.emailDomains;
            this.setState((prevState) => ({
              currentEnterpriseRule: [...emails],
            }));
            resolve("Domain added successfully");
          }
        })
        .catch(function (err) {
          reject("Error while adding domain");
          console.log(err);
        });
    });
  };

  handleSlackUrlAddRule = () => {
    let { slackUrlRule, allowedSlackWorkspaces } = this.state;
    // const isValidEmail = validateEmail(enterpriseRule.value);

    this.setState({
      slackUrlRule: {
        error: false,
      },
      error: "",
    });

    // console.log(enterpriseRule)
    let { value } = slackUrlRule;
    let orgId = this.props.user.profile.organizationId._id;

    if (!validateSlackUrl(value)) {
      this.setState({
        slackUrlRule: {
          value: slackUrlRule.value,
          error: true,
        },
        error: "Invalid url",
      });
    } else if (allowedSlackWorkspaces.indexOf(value) === -1) {
      axios
        .post(url.addSlackWorkspaceUrl, { url: value, orgId })
        .then(({ data }) => {
          console.log(data, "----", data.data);

          if (data && data.data) {
            // console.log('success')
            this.props.orgChangeSuccess(data.data);
            let urls = data.data.allowedSlackWorkspaces;
            this.setState((prevState) => ({
              allowedSlackWorkspaces: [...urls],
              slackUrlRule: { value: "", error: false },
              error: "",
            }));
          }
        })
        .catch((err) => {
          console.log(err);
          // this.setState({
          //   slackUrlRule: {
          //     value: slackUrlRule.value,
          //     error: true,
          //   },
          //   error: "Error while adding url",
          // });
        });
    } else {
      // this.setState({
      //   slackUrlRule: {
      //     value: slackUrlRule.value,
      //     error: true,
      //   },
      //   error: "This url already exists.",
      // });
    }
  };

  handleAddSlackUrl = async (data) => {
    return new Promise((resolve, reject) => {
      let orgId = this.props.user.profile.organizationId._id;
      data = {
        ...data,
        createdOn: new Date(),
      };
      axios
        .post(url.addSlackWorkspaceUrl, { url: data, orgId })
        .then(({ data }) => {
          if (data && data.data) {
            // console.log('success')
            this.props.orgChangeSuccess(data.data);
            let urls = data.data.allowedSlackWorkspaces;
            this.setState((prevState) => ({
              allowedSlackWorkspaces: [...urls],
            }));
            resolve("Url Added Successfully");
          }
        })
        .catch((err) => {
          console.log(err);
          reject("Error While Adding Url");
        });
    });
  };

  handleTeamsTenantAddRule = () => {
    let { teamTenantRule, allowedTeamsTenants } = this.state;
    // const isValidEmail = validateEmail(enterpriseRule.value);

    this.setState({
      teamTenantRule: {
        error: false,
      },
      error: "",
    });

    // console.log(enterpriseRule)
    let { value, name } = teamTenantRule;
    let orgId = this.props.user.profile.organizationId._id;

    if (!value || !name) {
      this.setState({
        teamTenantRule: {
          value: teamTenantRule.value,
          error: true,
        },
        error: "Please add Tenant id & name",
      });
    } else if (allowedTeamsTenants.indexOf((x) => x.tenantId == value) === -1) {
      axios
        .post(url.addTeamsTenantId, {
          url: {
            tenantId: value,
            name,
          },
          orgId,
        })
        .then(({ data }) => {
          console.log(data, "----", data.data);

          if (data && data.data) {
            // console.log('success')
            this.props.orgChangeSuccess(data.data);
            let urls = data.data.allowedTeamsTenants;
            this.setState((prevState) => ({
              allowedTeamsTenants: [...urls],
              teamTenantRule: { value: "", error: false, name: "" },
              error: "",
            }));
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            teamTenantRule: {
              value: teamTenantRule.value,
              error: true,
            },
            error: "Error while adding url",
          });
        });
    } else {
      this.setState({
        teamTenantRule: {
          value: teamTenantRule.value,
          error: true,
        },
        error: "This url already exists.",
      });
    }
  };

  handleAddTeamsWorkspace = (data) => {
    return new Promise((resolve, reject) => {
      let orgId = this.props.user.profile.organizationId._id;
      data = {
        ...data,
        createdOn: new Date(),
      };
      axios
        .post(url.addTeamsTenantId, {
          url: data,
          orgId,
        })
        .then(({ data }) => {
          console.log(data, "----", data.data);

          if (data && data.data) {
            // console.log('success')
            this.props.orgChangeSuccess(data.data);
            let urls = data.data.allowedTeamsTenants;
            this.setState((prevState) => ({
              allowedTeamsTenants: [...urls],
            }));
            resolve("Tenant Added Successfully");
          }
        })
        .catch((err) => {
          console.log(err);
          reject("Error While Adding Tenant");
        });
    });
  };

  emailError = (email) => {
    this.setState((prevState) => ({
      currentEnterpriseRule: [...this.props.emailDomains],
      enterpriseRule: { value: email, error: true },
      error: "This email already exists.",
    }));
  };
  urlError = (email) => {
    this.setState((prevState) => ({
      slackUrlRule: { value: url, error: true },
      error: "This url already exists.",
    }));
  };

  handleIndustrySave = () => {
    const { industryId, enterpriseName } = this.state;
    const minLength = 1;
    const maxLength = 100;
    const nameRegex = /^(?=.*[a-zA-Z])[a-zA-Z0-9\s]+$/;

    const showError = (message) => {
      toastContainer(message, "error");
      setTimeout(dismissToast, 3500);
    };

    if (industryId) {
      this.props.onIndustryChange(industryId);
    }

    const name = enterpriseName && enterpriseName.trim() || "";

    if (!name) {
      showError("Enterprise name cannot be empty.");
      return;
    }

    if (!nameRegex.test(name)) {
      showError("Enterprise name must contain only letters, numbers, and spaces.");
      return;
    }

    if (name.length < minLength || name.length > maxLength) {
      showError(`Enterprise name must be between ${minLength} and ${maxLength} characters.`);
      return;
    }

    this.props.onNameChange(name);
    this.toggleEditEnterpriseModal();
    this.setState({ industryId: "" });
  };


  handleEnterpriseRule = (event) => {
    // console.log(event.target.value)
    this.setState({ enterpriseRule: { value: event.target.value } });
  };
  handleSlackUrlRule = (event) => {
    // console.log(event.target.value)
    this.setState({ slackUrlRule: { value: event.target.value } });
  };
  handleTeamTenantRule = (event) => {
    // console.log(event.target.value)
    this.setState({
      teamTenantRule: {
        ...this.state.teamTenantRule,
        value: event.target.value,
      },
    });
  };
  handleTeamTenantRuleName = (event) => {
    // console.log(event.target.value)
    this.setState({
      teamTenantRule: {
        ...this.state.teamTenantRule,
        name: event.target.value,
      },
    });
  };

  showCustomEmailModal = () => {
    console.log("check");
    this.setState({ isEmailList: true });
  };

  closeEmailList = () => {
    this.setState({
      isEmailList: false,
      emailColumn: {},
      file: { name: "" },
      emailFieldOptions: [],
    });
  };

  handleEmailListSave = () => {
    this.setState({ inActiveSaveList: true });
    // console.log("save list")
    let { emailFieldOptions, file, emailColumn, csvValues } = this.state;
    let { profile } = this.props.user;
    // console.log('profile--', profile)

    if (emailFieldOptions) {
      let customEmailObject = {
        user: profile._id,
        organizationId: profile.organizationId._id,
        previewName: `File name: ${file.name} on ${moment(Date.now()).format(
          "YYYY-MM-DD"
        )}`,
        fileName: file.name,
        list: { field: emailColumn.category, data: csvValues },
      };

      axios.post(url.saveMailer, customEmailObject).then(({ data }) => {
        let result = data.data;
        this.setState({
          isEmailList: false,
          inActiveSaveList: false,
          customEmailObject: { ...result },
          emailColumn: {},
          file: { name: "" },
          emailFieldOptions: [],
        });
      });
    } else {
      this.setState({ file: { error: "No values or columns in .csv" } });
    }
  };

  handleFileUpload = ({ target }) => {
    let allowedFileSize = 20;
    let uploadFileHint = "(Only .csv files, maximum 20MB file size)";
    let file = target.files[0];
    // console.log(file)
    if (file) {
      let fileExtension = file.name.split(".")[file.name.split(".").length - 1];
      if (!["csv"].includes(fileExtension.toLowerCase())) {
        this.setState({
          file: { value: "", error: true, errorMessage: `${uploadFileHint}` },
        });
      } else if (file.size > 1024 * 1024 * allowedFileSize) {
        this.setState({
          file: {
            value: "",
            error: true,
            errorMessage: `Upload file size is more that ${allowedFileSize}MB`,
          },
        });
      } else {
        this.setState({
          file: { value: file, error: false, errorMessage: "" },
          fileName: file.name,
        });
      }
      this.setState({ file });
      // console.log('file ---', file)
      // this.fileName(file)
      this.processFile(file);
    }
  };

  handleDownloadQR = () => {
    const canvas = document.querySelector('#es-qrcode-canvas');
    if (!canvas) {
      toastContainer('QR not ready', 'error');
      return;
    }
    const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
    const link = document.createElement('a');
    link.href = pngUrl;
    link.download = 'SMS Chat QR.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    toastContainer('QR code downloaded.', 'success');
  };

  // fileName=(val)=>{
  //   // console.log(val)
  //   this.setState({fileName:val})
  // }

  processFile = (file) => {
    let csvFile = file;
    // console.log('process--',file)
    Papa.parse(csvFile, {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: "greedy",
      complete: this.handleCsvParseComplete,
    });
    // let selectedType = this.state.selectedType;
    //console.log("selectedType", selectedType);
    // console.log("")
    // if (!csvFile || !csvFile.name) {
    //   this.setState({file: {value: csvFile, error: true, errorMessage: 'Please select file.'}})
    // } else {
    //   Papa.parse(csvFile, {
    //     header: true,
    //     dynamicTyping: true,
    //     skipEmptyLines:'greedy',
    //     complete: this.handleCsvParseComplete
    //   });
    // }
  };

  handleCsvParseComplete = (result, file) => {
    const { fields } = result.meta;
    const { data } = result;
    // console.log('data--', data)
    // console.log('res--', result)
    // console.log('res fieldds ---', result.meta.fields)

    let emailObj = result.meta.fields.map((value, index) => {
      return { key: index, category: value };
    });

    // console.log('emailObj', emailObj)
    this.setState({ emailFieldOptions: emailObj, csvValues: data });
    //console.log(data);
    // this.props.onFileUpload(fields, data, this.state.file.value);
  };

  pickEmailColumn = (value) => {
    //  console.log(value)
    if (value && value !== null && value !== "null") {
      this.setState({
        emailColumn: { key: value.category, category: value.category },
      });
    }
  };

  handleImageUpload = ({ target }) => {
    console.log(target.files);
    let image = target.files[0];
    console.log(image);
    this.setState({ imageError: null });
    if (image) {
      let imageExt = image.name.split(".")[image.name.split(".").length - 1];

      let logoUrl = URL.createObjectURL(image);

      if (!["png", "jpg", "jpeg"].includes(imageExt.toLowerCase())) {
        this.setState({ imageError: "Not an image." });
      } else if (image.size > 1024 * 1024 * 10) {
        this.setState({ imageError: "Image is too big." });
      } else {
        // image.url = logoUrl
        // image.date = new Date()
        this.setState({
          logo: image,
          logoUrl: logoUrl,
          imageError: null,
          isWhiteLabelSave: true,
        });
      }
    }
  };

  whiteLabelModal = () => {
    let { profile } = this.props.user;
    this.setState((prevState) => ({
      isWhiteLabel: !prevState.isWhiteLabel,
      isWhiteLabelSave: false,
      alertMsg: "",
      imageError: null,
      whiteLabelName: profile.organizationId.name
        ? profile.organizationId.name
        : "",
      brandColor:
        profile.organizationId.whiteLabel &&
          profile.organizationId.whiteLabel.brandColor
          ? profile.organizationId.whiteLabel.brandColor
          : "",
      logo:
        profile.organizationId.whiteLabel &&
          profile.organizationId.whiteLabel.logo
          ? profile.organizationId.whiteLabel.logo
          : "",
      logoUrl:
        profile.organizationId.whiteLabel &&
          profile.organizationId.whiteLabel.logoUrl
          ? profile.organizationId.whiteLabel.logoUrl
          : "",
    }));
  };

  changeCompanyColor = (event) => {
    let { value } = event.target;
    this.setState({ brandColor: value, isWhiteLabelSave: true });
  };

  changeCompanyName = (event) => {
    let { value } = event.target;
    this.setState({ whiteLabelName: value, isWhiteLabelSave: true });
  };

  handleSaveWhitelabel = () => {
    this.setState({ alertMsg: "" });

    let {
      whiteLabelName,
      brandColor,
      simpleEmailBranding,
      logoUrl,
      logo,
    } = this.state;
    let payload = { ...this.props.user.profile.organizationId };
    const formData = new FormData();
    let image_url = logo && logo.url ? logo.url : logoUrl;

    if (whiteLabelName && whiteLabelName !== "") {
      if (brandColor && brandColor != "" && logo && image_url != "") {
        console.log("imgUrl---", image_url);
        formData.append("brandColor", brandColor);
        formData.append("image", logo);
        formData.append("imageUrl", image_url);
        payload = {
          whiteLabel: {
            brandColor,
            logo: {
              url: image_url,
              name: logo.name,
            },
          },
        };
        console.log("img, brand");
      } else if (logo && image_url != "" && (!brandColor || brandColor == "")) {
        formData.append("image", logo);
        formData.append("imageUrl", image_url);
        payload = {
          whiteLabel: {
            ...payload.whiteLabel,
            logo: {
              url: image_url,
              name: logo.name,
            },
          },
        };
        console.log("img");
      } else if ((!logo || image_url == "") && brandColor && brandColor != "") {
        formData.append("brandColor", brandColor);
        payload = {
          whiteLabel: {
            ...payload.whiteLabel,
            brandColor,
          },
        };
        console.log("brand");
      }
      if (
        whiteLabelName !== this.props.user.profile.organizationId.name &&
        whiteLabelName !== ""
      ) {
        payload.name = whiteLabelName;
        formData.append("name", whiteLabelName);
      }

      payload = {
        ...payload,
        whiteLabel: {
          ...payload.whiteLabel,
          simpleEmailBranding,
        },
      };

      formData.append("simpleEmailBranding", simpleEmailBranding);

      formData.append("payload", JSON.stringify(payload));

      if (Object.keys(payload).length > 0) {
        this.props.orgChangeSuccess(payload);

        axios.post(url.whiteLabel, formData).then(({ data }) => {
          if (data && data.data) {
            this.props.orgChangeSuccess(data.data);
            this.setState({
              isWhiteLabel: false,
              alertMsg: "",
              imageError: null,
            });
          }
        });
      }
    } else {
      this.setState({ alertMsg: "name" });
    }

    // else {

    // }
  };

  handleBrandedEmails = (changeEvent) => {
    console.log("branding ---- ", changeEvent.target.checked);
    this.setState({
      simpleEmailBranding: changeEvent.target.checked,
      isWhiteLabelSave: true,
    });
  };

  resetWhiteLabel = (attr) => {
    const formData = new FormData();
    let { whiteLabel } = this.props.user.profile.organizationId;
    let res = { isWhiteLabel: false };
    if (attr == "brandColor") {
      formData.append("brandColor", "");
      whiteLabel = { ...whiteLabel, brandColor: "" };
      // this.props.orgChangeSuccess(whiteLabel)
      res = { ...res, brandColor: false };
    }

    if (attr == "logo") {
      formData.append("image", "");
      whiteLabel = { ...whiteLabel, logo: "" };
      res = { ...res, logo: false };
      // this.props.orgChangeSuccess(whiteLabel)
    }

    this.props.orgChangeSuccess({ whiteLabel: { ...whiteLabel } });
    // payload={...payload, whiteLabel}

    axios.post(url.whiteLabel, formData).then(({ data }) => {
      this.setState(res);
    });
  };

  enableModule = (module) => {
    let {
      isPlanning,
      isToolkit,
      isCultureApp,
      isAnalytics,
      isGroups,
      isDiversityCalendar,
      isDEIMaturityModel
    } = this.props.user.profile.organizationId;
    let { selectedReourceRestrictions } = this.state;
    // console.log(isPlanning,isToolkit, module)
    let isDisplayed;
    let status;
    if (module === "isPlanning") {
      isDisplayed = isPlanning && isPlanning.isDisplayed == true ? false : true;
      status = isPlanning && isPlanning.status;
    } else if (module === "isCultureApp") {
      isDisplayed =
        isCultureApp && isCultureApp.isDisplayed == true ? false : true;
      status = isCultureApp && isCultureApp.status;
    } else if (module === "isAnalytics") {
      isDisplayed =
        isAnalytics && isAnalytics.isDisplayed == true ? false : true;
      status = isAnalytics && isAnalytics.status;
    } else if (module === "isGroups") {
      isDisplayed = isGroups && isGroups.isDisplayed == true ? false : true;
      status = isGroups && isGroups.status;
    } else if (module === "isDiversityCalendar") {
      isDisplayed =
        isDiversityCalendar && isDiversityCalendar.isDisplayed == true
          ? false
          : true;
      status = isDiversityCalendar && isDiversityCalendar.status;

    } else if (module === "isDEIMaturityModel") {
      isDisplayed =
        isDEIMaturityModel && isDEIMaturityModel.isDisplayed == true
          ? false
          : true;
      status = isDEIMaturityModel && isDEIMaturityModel.status;
    }

    else {
      this.setState({ selectedReourceRestrictions });
      this.storeRestrictions(selectedReourceRestrictions);
      isDisplayed = isToolkit && isToolkit.isDisplayed == true ? false : true;
      status = isToolkit && isToolkit.status;
    }

    let payload = {
      module,
      isDisplayed,
      status,
    };
    // console.log('-enable--', payload)

    axios.post(url.enableModule, payload).then(({ data }) => {
      // console.log(data)
      if (data && data.data) {
        this.props.orgChangeSuccess(data.data);
        this.setState({ [module]: isDisplayed });
      }
    });
  };

  resourceModuleRestriction = (restrictions) => {
    console.log("restrictions --- ", restrictions);
    this.setState({
      selectedReourceRestrictions: [...restrictions],
    });

    let payload = {
      restrictions,
      module: "isToolkit",
    };

    axios.post(url.restrictModuleSettings, payload).then(({ data }) => {
      // console.log(data)
      if (data && data.data) {
        this.storeRestrictions(restrictions);
      }
    });
  };

  changePlatformAccess = (changeEvent) => {
    console.log("changeEvent ---- ", changeEvent);
    console.log("branding ---- ", changeEvent.target.checked);

    let { checked } = changeEvent.target;

    let res;

    if (checked) {
      res = ["SSO"];
    } else {
      res = [];
    }

    axios
      .put(url.changeOrgOAuth, { oauth: res })
      .then(({ data }) => {
        console.log("success");
        this.props.orgChangeSuccess(data.data);
      })
      .catch((err) => {
        console.log("err --- ", err);
      });
  };


  toggleMFA = (changeEvent) => {
    let { checked } = changeEvent.target;
    axios
      .put(url.changeOrgOAuth, { mfa: { isEnabled: checked } })
      .then(({ data }) => {
        console.log("success");
        this.props.orgChangeSuccess(data.data);
      })
      .catch((err) => {
        console.log("err --- ", err);
      });
  };

  showToggleUiForModule = (moduleName) => {
    const { organizationId } = this.props.user.profile;

    if (organizationId.selectModule) {
      if (organizationId[moduleName] && organizationId[moduleName].status) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  render() {
    const {
      showEditEnterpriseModal,
      industryId,
      currentEnterpriseRule,
      inActiveSaveList,
      isWhiteLabel,
      whiteLabelName,
      logoUrl,
      logo,
      brandColor,
      simpleEmailBranding,
      isEmailList,
      file,
      customEmailObject,
      isWhiteLabelSave,
      alertMsg,
      imageError,
      diversityFocusOptions,
      selectedReourceRestrictions,
      allowedSlackWorkspaces,
      slackUrlRule,
      allowedTeamsTenants,
      enterpriseName,
    } = this.state;

    console.log(industry, 'industry');
    const {
      existingMapping,
      enterpriseInformation,
      industriesList,
      user,
    } = this.props;
    let { profile } = this.props.user;
    const { organizationId } = this.props.user.profile;

    let industry_id =
      profile.organizationId.industry &&
        profile.organizationId.industry._id &&
        profile.organizationId.industry._id != null
        ? profile.organizationId.industry._id
        : profile.organizationId.industry;

    const industry = find(industriesList, { _id: industry_id });
    console.log(industriesList, '676767')
    console.log(industry_id, '676767')
    console.log(industry, '676767')

    let {
      isPlanning,
      isToolkit,
      isCultureApp,
      isGroups,
      isAnalytics,
      slackPopupOpen,
      teamsPopupOpen,
      domainsPopupOpen,
      slackOrgPopupOpen,
      isDiversityCalendar,
      isDEIMaturityModel
    } = this.state;

    let onlyOAuth =
      organizationId &&
      organizationId.authentication_methods &&
      organizationId.authentication_methods.length > 0 &&
      organizationId.authentication_methods.indexOf("SSO") > -1;


    const enableOnlyMFA = organizationId && organizationId.mfa && organizationId.mfa.isEnabled

    return (
      <div
        className="mt40"
        style={{
          backgroundColor: this.state.color ? `${this.state.color}` : "",
        }}
      >
        <div className="container">
          <div className="row text-left enterprise-setting-label mb-4">
            <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
              <OoPopover
                target="enterprise-name-popover"
                placement="left"
                headerText="Enterprise QR code"
                bodyText={`Share this QR code so employees can scan it and sign up with their phone number.`}
              />
              Enterprise QR code
            </div>
            <div className="col-md-8 col-lg-8 enterprise-settings-value">
              <EnterpriseQrCode orgId={organizationId._id} />
            </div>
          </div>
          <div className="row text-left enterprise-setting-label mb-4">
            <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
              <OoPopover
                target="enterprise-name-popover"
                placement="left"
                headerText="Enterprise Name"
                bodyText={`Your enterprise name is set when the enterprise account is created. You can change it by clicking Edit Enterprise Information.`}
              />
              Enterprise Name
            </div>

            {/* <span onClick={()=>this.colorChange()}>Change color</span> */}
            <div className="col-md-8 col-lg-8 enterprise-settings-value">
              <div
                style={{
                  maxWidth: '100%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  wordWrap: 'break-word',
                  whiteSpace: 'nowrap'
                }}
                title={enterpriseInformation && enterpriseInformation.name}
              >
                {enterpriseInformation && enterpriseInformation.name}
              </div>
              <div className="mt-1 cursor-pointer" style={{ color: "#5099DE" }}>
                <span onClick={this.toggleEditEnterpriseModal}>
                  Edit Enterprise Information
                </span>
              </div>
            </div>
          </div>
          <div className="row text-left enterprise-setting-label mb-4">
            <div className="col-md-4 col-lg-4 text-right enterprise-setting-label pl3em enterpriseSettingsIndustry">
              <OoPopover
                target="enterprise-industry-popover"
                placement="left"
                headerText="Enterprise Industry"
                bodyText={`Your enterprise industry is set when the enterprise account is created. You can change it by clicking Edit Enterprise Information.`}
              />
              Enterprise Industry
            </div>
            <div className="col-md-8 col-lg-8 enterprise-settings-value">
              <div>{industry ? industry.name : ""}</div>
              <div className="mt-1 cursor-pointer" style={{ color: "#5099DE" }}>
                <span onClick={this.toggleEditEnterpriseModal}>
                  Edit Enterprise Information
                </span>
              </div>
            </div>
          </div>

          <div className="row text-left enterprise-setting-label mb-4">
            <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
              <OoPopover
                target="sms-chats-popover"
                placement="left"
                headerText="User-Initiated SMS Chats"
                bodyText="Chats can be initiated by any user via SMS text and consume SMS credits. Only the predefined recipient(s) for each chat will receive the user’s SMS and can respond on the platform."
              />
              User-Initiated SMS Chats
            </div>
            <div className="col-md-8 col-lg-8 enterprise-settings-value">
              <button
                onClick={() => this.setState({ showSmsRoutingModal: true })}
                style={{
                  backgroundColor: "#fff",
                  color: "#1e293b",
                  border: "1px solid #e2e8f0",
                  borderRadius: "10px",
                  padding: "10px 20px",
                  fontWeight: "500",
                  fontSize: "15px",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                Set up User-Initiated SMS Chats
              </button>

              {this.state.smsRoutingConfigured && (
                <div
                  className="mt-3"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "10px",
                    backgroundColor: "#eff6ff",
                    border: "1px solid #dbeafe",
                    borderRadius: "12px",
                    padding: "12px 18px",
                    fontSize: "15px",
                    color: "#475569",
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.77 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.5a16 16 0 0 0 5.58 5.58l1.06-1.06a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 15.22z"></path></svg>
                  <span>
                    Share: <strong style={{ color: "#1e293b", letterSpacing: "0.02em" }}>{this.state.smsPhoneNumber}</strong>
                    {" "}or{" "}
                    <span
                      style={{ color: "#3b82f6", cursor: "pointer", fontWeight: "500" }}
                      onClick={this.handleDownloadQR}
                    >
                      download QR code
                    </span>
                  </span>
                  <div style={{ position: 'absolute', left: '-9999px' }}>
                    <QRCodeCanvas
                      id="es-qrcode-canvas"
                      level="H"
                      size={200}
                      value={`${baseUrl().replace(/\/$/, '')}/employee-register?orgId=${this.props.user.profile.organizationId._id}&phone=${encodeURIComponent((this.state.smsPhoneNumber || '').trim())}&firstName=${encodeURIComponent((this.state.smsFirstName || '').trim())}&lastName=${encodeURIComponent((this.state.smsLastName || '').trim())}`}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* <div className="row mb40">
            <div className="col-md-4 col-lg-4 text-right pl-0">
              <div className="enterprise-setting-label">
                <OoPopover
                  target="enterprise-rule-popover"
                  placement="left"
                  headerText="Enterprise Invite Rule"
                  bodyText={`Grant limited access (currently only to the "Culture App" module) to anyone with an email address that contains the domain you specify in the enterprise invite rule. You will not need to invite these members individually.`}
                />
                Enterprise Invite Rule
              </div>
              <div
                className="mt-2 cursor-pointer text-left"
                style={{ color: "#5099DE", marginLeft: "38px" }}
                onClick={() =>
                  this.setState({
                    domainsPopupOpen: { open: true, tab: 1 },
                  })
                }
              >
                <span>Add Email</span>{" "}
                <MdOutlineMailOutline size={"18px"} className="mb-1" />
              </div>
            </div>

            <div className="col-md-8 col-lg-8 enterprise-settings-value">
              <div>
                {currentEnterpriseRule && currentEnterpriseRule.length > 0 ? (
                  <div>
                    {currentEnterpriseRule[0] ? (
                      <span
                        onClick={() =>
                          this.removeOrgEmail(currentEnterpriseRule[0])
                        }
                        className="orgEmailRule"
                      >
                        {currentEnterpriseRule[0]} X
                      </span>
                    ) : (
                      ""
                    )}
                    {currentEnterpriseRule[1] ? (
                      <span
                        onClick={() =>
                          this.removeOrgEmail(currentEnterpriseRule[1])
                        }
                        className="orgEmailRule"
                      >
                        {currentEnterpriseRule[1]} X
                      </span>
                    ) : (
                      ""
                    )}

                    <div
                      className="mt-2 cursor-pointer text-left"
                      style={{ color: "#5099DE" }}
                      onClick={() =>
                        this.setState({
                          domainsPopupOpen: { open: true, tab: 2 },
                        })
                      }
                    >
                      <span>See more emails</span>{" "}
                    </div>
                  </div>
                ) : <span>No email domains</span>}

                {domainsPopupOpen.open && (
                  <EmailDomainsPopup
                    open={domainsPopupOpen.tab}
                    addApi={this.handleAddDomain}
                    allowedDomains={currentEnterpriseRule}
                    removeDomain={this.removeOrgEmail}
                    onClose={() => {
                      this.setState({ domainsPopupOpen: { open: false } });
                    }}
                  />
                )}
              </div>
              {this.state.enterpriseRule.error && this.state.error !== "" ? (
                <p className="emailError"> {this.state.error} </p>
              ) : null}
            </div>
          </div>

          <div className="row mb40">
            <div className="col-md-4 col-lg-4 text-right pl-0">
              <div className="enterprise-setting-label">
                <OoPopover
                  target="slack-rule-popover"
                  placement="left"
                  headerText="Allowed Slack Workspaces"
                  bodyText={`Enter allowed slack workspaces url so users in your organization can only access those to share content in slack`}
                />
                Allowed Slack Accounts
              </div>

              <div
                className="mt-2 cursor-pointer text-left"
                style={{ color: "#5099DE", marginLeft: "38px" }}
                onClick={() =>
                  this.setState({
                    slackPopupOpen: { open: true, tab: 1 },
                  })
                }
              >
                <span>Link Slack</span>{" "}
                <BiLogoSlack size={"18px"} className="mb-1" />
              </div>
            </div>

            <div className="col-md-8 col-lg-8 enterprise-settings-value">
              <div>
                {allowedSlackWorkspaces && allowedSlackWorkspaces.length > 0 ? (
                  <div>
                    <div
                      className="orgEmailRule"
                    >
                      {allowedSlackWorkspaces[0].workspaceId}{" "}
                      <span
                        onClick={() =>
                          this.removeWorkspaceUrl(allowedSlackWorkspaces[0])
                        }
                      >
                        X
                      </span>
                    </div>
                    <div
                      className="mt-2 cursor-pointer text-left"
                      style={{ color: "#5099DE" }}
                      onClick={() =>
                        this.setState({
                          slackPopupOpen: { open: true, tab: 2 },
                        })
                      }
                    >
                      <span>See more slack accounts</span>{" "}
                    </div>
                  </div>
                ) : (
                  <div >
                    <span style={{verticalAlign:"middle"}}>No slack accounts</span>{" "}
                  </div>
                )}

                {slackPopupOpen.open && (
                  <AllowedWorkspacesComp
                    open={slackPopupOpen.tab}
                    onClose={() => this.setState({ slackPopupOpen: false })}
                    addApi={this.handleAddSlackUrl}
                    allowedWorkspaces={allowedSlackWorkspaces || []}
                    removeWorkspace={this.removeWorkspaceUrl}
                    popupType={"Slack"}
                  />
                )}
              </div>
              {this.state.slackUrlRule.error && this.state.error !== "" ? (
                <p className="emailError"> {this.state.error} </p>
              ) : null}
            </div>
          </div> */}


          <div className="row mb40">
            <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
              <OoPopover
                target="sso-platform-access"
                placement="left"
                headerText="Sign In/ Log in Platform Access"
                bodyText={`Only allow access to platform via SSO`}
              />
              Only allow Single Sign On (SSO) to {isTrivvyUrl(organizationId) ? "Trivvy" : "OurOffice"}  Platform
            </div>
            <div className="col-md-8 col-lg-8 enterprise-settings-value">
              <Toggle
                checked={onlyOAuth}
                icons={
                  true
                  // {
                  //   checked: 'Disable',
                  //   unchecked: 'Enable'
                  // }
                }
                className="moduleToggleSwitch"
                onChange={this.changePlatformAccess}
              />
            </div>
          </div>
          <div className="row mb40">
            <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
              <OoPopover
                target="mfa-platform-access"
                placement="left"
                headerText="Multi-Factor Authentication (MFA)"
                bodyText={`When enabled, all Admins must use MFA to sign in for added security.`}
              />
              Enable Multi Factor Authentication(MFA)
            </div>
            <div className="col-md-8 col-lg-8 enterprise-settings-value">
              <Toggle
                checked={enableOnlyMFA}
                icons={
                  true
                  // {
                  //   checked: 'Disable',
                  //   unchecked: 'Enable'
                  // }
                }
                className="moduleToggleSwitch"
                onChange={this.toggleMFA}
              />
            </div>
          </div>

          <div className="row text-left enterprise-setting-label mb-4 emailListContainer">
            <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
              <OoPopover
                target="modal-popover"
                placement="left"
                headerText="White label"
                bodyText={`Change the logo and the name to display on the top left corner and select a primary color.`}
              />
              White label
            </div>
            <div
              className="col-md-8 cursor-pointer"
              style={{ color: "#5099DE" }}
              onClick={() => this.whiteLabelModal()}
            >
              {organizationId.whiteLabel &&
                ((organizationId.whiteLabel.logo &&
                  organizationId.whiteLabel.logo.name &&
                  organizationId.whiteLabel.logo.name.length > 0) ||
                  (organizationId.whiteLabel.brandColor &&
                    organizationId.whiteLabel.brandColor.length > 0)) ? (
                <span>
                  {/* Modified on {moment(organizationId.whiteLabel.logo.date).format("MM/DD/YYYY")} */}
                  Modified
                  {organizationId.whiteLabel.brandColor &&
                    organizationId.whiteLabel.brandColor.length > 0 &&
                    organizationId.whiteLabel.logo &&
                    organizationId.whiteLabel.logo.name &&
                    organizationId.whiteLabel.logo.name.length > 0
                    ? " brand color and logo"
                    : organizationId.whiteLabel.brandColor &&
                      organizationId.whiteLabel.brandColor.length > 0 &&
                      (!organizationId.whiteLabel.logo ||
                        organizationId.whiteLabel.logo == "")
                      ? " brand color"
                      : organizationId.whiteLabel.logo &&
                        organizationId.whiteLabel.logo.name &&
                        organizationId.whiteLabel.logo.name.length > 0 &&
                        !organizationId.whiteLabel.brandColor &&
                        organizationId.whiteLabel.brandColor == ""
                        ? " logo"
                        : null}
                  {/* File "{organizationId.whiteLabel.logo.name}", Uploaded on {moment(organizationId.whiteLabel.logo.date).format("MM/DD/YYYY")} */}
                  <img className="ml10" src={MappedIcon} />
                </span>
              ) : (
                <span>Customize brand colors and logo</span>
              )}
            </div>

            <Modal isOpen={isWhiteLabel} className="drill-down-modal">
              <ModalBody>
                <div className="row mt-1">
                  <div className="offset-md-1 offset-lg-1 pick-office-modal-body-title mb20">
                    Manage White label
                  </div>
                </div>

                <div className="offset-md-1 offset-xs-1col-lg-11 col-md-11 col-xs-11 noPadding whiteLabelModal">
                  <span className="whiteLabelInputTxt">
                    Change name
                    <input
                      type="text"
                      className="whiteLabelInput"
                      value={whiteLabelName}
                      id="enterpriseRule"
                      onChange={this.changeCompanyName}
                      placeholder={"Choose a name"}
                    />
                    {alertMsg === "name" ? (
                      <span className="settingErrMsg">
                        Name can not be blank
                      </span>
                    ) : null}
                  </span>

                  <span className="whiteLabelInputTxt">
                    Select brand color
                    <input
                      type="color"
                      className="brandColor"
                      value={
                        this.state.brandColor
                          ? this.state.brandColor
                          : isTrivvyUrl(organizationId) ? trivvyStandardColor : ooStandardColor
                      }
                      id="enterpriseRule"
                      onChange={this.changeCompanyColor}
                      placeholder={"Choose a brand color"}
                    // invalid={this.state.enterpriseRule.error}
                    />
                    {organizationId.whiteLabel &&
                      organizationId.whiteLabel.brandColor ? (
                      <span
                        className="resetWhiteLabelTxt"
                        onClick={() => this.resetWhiteLabel("brandColor")}
                      >
                        Reset ?
                      </span>
                    ) : null}
                  </span>

                  <span sm={9} className="noPadding">
                    <span className="logoContainerTxt">
                      <Label
                        htmlFor="image-upload"
                        className="custom-file-upload"
                      >
                        <i className="fa fa-cloud-upload"></i>{" "}
                        <span className="select-file">Select logo</span>
                      </Label>

                      <input
                        id="image-upload"
                        onChange={this.handleImageUpload}
                        type="file"
                      />

                      <span className="logoRequired">
                        <span>*Image cane be up to 10mbs</span>
                        <span>*Formats: png, jpeg/jpg </span>
                      </span>
                    </span>

                    {logo && (logo.url != "" || logoUrl !== "") ? (
                      <div className="previewPhotoContainer">
                        {/* <span className= "removePreview" onClick={() => this.setState({logo:"", logoUrl:""})}>
                    X
                  </span> */}
                        <img
                          className="previewPhoto"
                          src={logoUrl != "" ? logoUrl : logo.url}
                        />
                        {/* <span className="ml10 no-file-chosen">{image.name}</span> */}
                      </div>
                    ) : null}

                    {logo && logo.name !== "" ? (
                      <span className="ml10 no-file-chosen logoName">
                        {logo.name}
                      </span>
                    ) : (
                      <span className="ml10">No image selected</span>
                    )}

                    {organizationId.whiteLabel &&
                      organizationId.whiteLabel.logo ? (
                      <span
                        className="resetWhiteLabelTxt"
                        onClick={() => this.resetWhiteLabel("logo")}
                      >
                        Reset ?
                      </span>
                    ) : null}
                  </span>

                  {imageError ? (
                    <p className="logoError settingErrMsg"> {imageError} </p>
                  ) : null}

                  <span className="whiteLabelInputTxt sb_email_01">
                    <OoPopover
                      target="whitelabel-simple-branded-emails"
                      placement="left"
                      headerText="Branded Emails"
                      bodyText={`All emails sent from the platform will be branded with your company's Name and Logo`}
                    />
                    <span className="fl_lt">
                      Brand emails with Company Name and Logo
                    </span>
                    <span className="ml10">
                      <Toggle
                        checked={simpleEmailBranding}
                        icons={false}
                        onChange={this.handleBrandedEmails}
                      />
                    </span>
                  </span>
                </div>

                <div className="col-xs-12 mt40 whitelabel_sc_container">
                  <div className="col-lg-6 col-md-6 inlineBlock">
                    {isWhiteLabelSave ? (
                      <Button
                        className={
                          inActiveSaveList
                            ? "profile-modal-save-btn wrapped-component-on-loading"
                            : "profile-modal-save-btn"
                        }
                        onClick={() => this.handleSaveWhitelabel()}
                      >
                        <span className="profile-modal-save-btn-txt">
                          Save
                          {/* <span className="ml10 flaticon-tick"></span> */}
                        </span>
                      </Button>
                    ) : (
                      <Button className="inactiveSave">
                        <span className="profile-modal-save-btn-txt">Save</span>
                      </Button>
                    )}
                  </div>

                  <div className="col-lg-6 col-md-6 inlineBlock">
                    <Button
                      className="profile-modal-cancel-btn"
                      onClick={() => this.whiteLabelModal()}
                    >
                      <span className="profile-modal-cancel-btn-txt">
                        Cancel
                      </span>
                    </Button>
                  </div>
                </div>
              </ModalBody>
            </Modal>
          </div>


          {
            !isTrivvyUrl(organizationId) && <div className="row text-left enterprise-setting-label mb-4 emailListContainer">
              <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                <OoPopover
                  target="modal-popover"
                  placement="left"
                  headerText="Custom Email List"
                  bodyText={`Upload a .csv File of Emails for the Option to Notify Them of Your EA Posts`}
                />
                Custom Email list
              </div>
              <div
                className="col-md-8 cursor-pointer"
                style={{ color: "#5099DE" }}
                onClick={() => this.showCustomEmailModal()}
              >
                {customEmailObject &&
                  customEmailObject.fileName &&
                  customEmailObject.createdOn ? (
                  <span>
                    File "{customEmailObject.fileName}", Uploaded on{" "}
                    {moment(customEmailObject.createdOn).format("MM/DD/YYYY")}
                    <img className="ml10" src={MappedIcon} />
                  </span>
                ) : (
                  <span>Upload file</span>
                )}

                <Modal isOpen={isEmailList} className="drill-down-modal">
                  <ModalBody>
                    {inActiveSaveList ? (
                      <img
                        src={Spinner}
                        className="spinner-pos"
                        style={{ top: "28%" }}
                      />
                    ) : null}

                    <div className="row mt-1">
                      <div className="offset-md-1 offset-lg-1 pick-office-modal-body-title mb20">
                        Create Custom Email List
                      </div>
                    </div>

                    <div className="offset-md-1 offset-xs-1col-lg-11 col-md-11 col-xs-11 noPadding">
                      <div
                        className="col-lg-6 col-md-6 col-xs-6 inlineBlock mb20"
                        style={{ fontSize: "19px" }}
                      >
                        Upload Email List:{" "}
                        <Label
                          for="file-upload"
                          className="custom-file-upload"
                          style={{
                            width: "100%",
                            display: "inline",
                            padding: "2px 20px 3px 20px",
                            textAlign: "center",
                          }}
                        >
                          <span className="select-file">Select File</span>
                        </Label>
                        <input
                          id="file-upload"
                          onChange={this.handleFileUpload}
                          type="file"
                          accept=".csv,.CSV"
                        />
                        {file.error ? (
                          <span className="upload-file-err-msg">
                            {file.errorMessage}
                          </span>
                        ) : null}
                      </div>

                      {file.name ? (
                        <div className="col-lg-12 col-md-12 col-xs-12 mb20">
                          <strong> File name: </strong> {file.name}
                        </div>
                      ) : null}

                      {this.state.emailFieldOptions &&
                        this.state.emailFieldOptions.length > 0 ? (
                        <div className="col-lg-12 col-md-12 col-xs-12 inlineBlock">
                          Please select the column with the emails :
                          <Select
                            className="map-table-dropdown col-lg-6 col-md-6 noPadding"
                            placeholder="Please select email column"
                            options={this.state.emailFieldOptions}
                            onChange={this.pickEmailColumn}
                            value={this.state.emailColumn}
                            valueKey="key"
                            labelKey="category"
                          />
                        </div>
                      ) : null}
                    </div>

                    <div className="col-xs-11 mt40 offset-md-1 offset-xs-1">
                      <div className="col-lg-6 col-md-6 inlineBlock">
                        {this.state.emailColumn &&
                          this.state.emailColumn.key &&
                          this.state.emailColumn.category ? (
                          <Button
                            className={
                              inActiveSaveList
                                ? "profile-modal-save-btn wrapped-component-on-loading"
                                : "profile-modal-save-btn"
                            }
                            onClick={this.handleEmailListSave}
                          >
                            <span className="profile-modal-save-btn-txt">
                              Save
                              <span className="ml10 flaticon-tick"></span>
                            </span>
                          </Button>
                        ) : (
                          <Button className="inactiveSave">
                            <span className="profile-modal-save-btn-txt">
                              Save
                              <span className="ml10 flaticon-tick"></span>
                            </span>
                          </Button>
                        )}
                      </div>

                      <div className="col-lg-6 col-md-6 inlineBlock">
                        <Button
                          className="profile-modal-cancel-btn"
                          onClick={this.closeEmailList}
                        >
                          <span className="profile-modal-cancel-btn-txt">
                            Cancel
                          </span>
                        </Button>
                      </div>
                    </div>
                  </ModalBody>
                </Modal>
              </div>

              {/* <EmailList isEmailList={this.state.isEmailList} /> */}
              {/* EmailList */}
            </div>
          }

          {
            !isTrivvyUrl(organizationId) && <div>
              <div className="row text-left enterprise-setting-label mb-4">
                <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                  <OoPopover
                    target="office-hierarchy-popover"
                    placement="left"
                    headerText="Office Hierarchy"
                    bodyText={`Organize your enterprise offices in the appropriate hierarchy for KPI calculations and drill-downs.`}
                  />
                  Office Hierarchy
                </div>
                <div className="col-md-8 col-lg-8 enterprise-settings-value">
                  {organizationId && organizationId.staticHierarchy ? (
                    <div>
                      Office Hierarchy Built
                      <img className="ml10" src={MappedIcon} />
                      <div
                        className="mt-1 cursor-pointer"
                        style={{ color: "#5099DE" }}
                      >
                        <span
                          onClick={() => {
                            this.props.history.push(
                              "/home/enterprise-info/org-chart"
                            );
                          }}
                        >
                          Import New or Change Current Office Hierarchy
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <span style={{ color: "#F38F81" }}>
                        Office Hierarchy Built
                      </span>
                      <div
                        className="mt-1 cursor-pointer"
                        style={{ color: "#5099DE" }}
                      >
                        <span
                          onClick={() => {
                            this.props.history.push("/setup/org-chart");
                          }}
                        >
                          Import Office Hierarchy
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {organizationId ? (
                <span>
                  {this.showToggleUiForModule("isToolkit") ? (
                    <div className="row text-left enterprise-setting-label mb-4">
                      <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                        <OoPopover
                          target="toolkit-module-access"
                          placement="left"
                          headerText="Toolkit Module"
                          bodyText={`Grant or remove access to the ${staticTitles.toolkit_lg} Module for all users`}
                        />
                        {isToolkit ? "Disable" : "Enable"}{" "}
                        {staticTitles.toolkit_lg} Module
                      </div>
                      <div className="col-md-8 col-lg-8 enterprise-settings-value">
                        <Toggle
                          checked={isToolkit}
                          icons={true}
                          className="moduleToggleSwitch"
                          onChange={() => this.enableModule("isToolkit")}
                        />
                      </div>
                    </div>
                  ) : null}

                  {isToolkit && (
                    <div className="row text-left enterprise-setting-label mb-4">
                      <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                        <OoPopover
                          target="toolkit-module-access"
                          placement="left"
                          headerText="Toolkit Module"
                          bodyText={`Grant or remove access to the ${staticTitles.toolkit_lg} Module for all users`}
                        />
                        Resource Module Restrictions
                      </div>
                      <div className="col-md-8 col-lg-8 enterprise-settings-value">
                        <Select
                          name="restriction-select"
                          placeholder={"Select"}
                          value={selectedReourceRestrictions}
                          onChange={
                            (val) => this.resourceModuleRestriction(val)
                            // restrictions => {
                            //   this.setState({
                            //     selectedReourceRestrictions: [...restrictions],
                            //   });
                            //   this.storeRestrictions(restrictions);
                            // }
                          }
                          options={diversityFocusOptions}
                          valueKey="key"
                          labelKey="focus"
                          getOptionLabel={({ focus }) => focus}
                          getOptionValue={({ key }) => key}
                          multi
                        />
                      </div>
                    </div>
                  )}

                  {this.showToggleUiForModule("isPlanning") ? (
                    <div className="row text-left enterprise-setting-label mb-4">
                      <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                        <OoPopover
                          target="planning-module-access"
                          placement="left"
                          headerText="Planning Module"
                          bodyText={`Grant or remove access to the Planning Module for all users`}
                        />
                        {isPlanning ? "Disable" : "Enable"} Planning Module
                      </div>
                      <div className="col-md-8 col-lg-8 enterprise-settings-value">
                        <Toggle
                          checked={isPlanning}
                          icons={
                            true
                            // {
                            //   checked: 'Disable',
                            //   unchecked: 'Enable'
                            // }
                          }
                          className="moduleToggleSwitch"
                          onChange={() => this.enableModule("isPlanning")}
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {this.showToggleUiForModule("isDiversityCalendar") ? (
                    <div className="row text-left enterprise-setting-label mb-4">
                      <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                        <OoPopover
                          target="planning-module-access"
                          placement="left"
                          headerText="Calendar of Observances Module"
                          bodyText={`Grant or remove access to the Calendar of Observances Module for all users`}
                        />
                        {isDiversityCalendar ? "Disable" : "Enable"} Calendar of Observances Module
                      </div>
                      <div className="col-md-8 col-lg-8 enterprise-settings-value">
                        <Toggle
                          checked={isDiversityCalendar}
                          icons={
                            true
                            // {
                            //   checked: 'Disable',
                            //   unchecked: 'Enable'
                            // }
                          }
                          className="moduleToggleSwitch"
                          onChange={() =>
                            this.enableModule("isDiversityCalendar")
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {this.showToggleUiForModule("isDEIMaturityModel") ? (
                    <div className="row text-left enterprise-setting-label mb-4">
                      <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                        <OoPopover
                          target="planning-module-access"
                          placement="left"
                          headerText="Workplace Assessment Module"
                          bodyText={`Grant or remove access to the  Workplace Assessment Module for all users`}
                        />
                        {isDEIMaturityModel ? "Disable" : "Enable"} Workplace Assessment Module
                      </div>
                      <div className="col-md-8 col-lg-8 enterprise-settings-value">
                        <Toggle
                          checked={isDEIMaturityModel}
                          icons={
                            true
                            // {
                            //   checked: 'Disable',
                            //   unchecked: 'Enable'
                            // }
                          }
                          className="moduleToggleSwitch"
                          onChange={() =>
                            this.enableModule("isDEIMaturityModel")
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {this.showToggleUiForModule("isCultureApp") ? (
                    <div className="row text-left enterprise-setting-label mb-4">
                      <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                        <OoPopover
                          target="culturapp-module-access"
                          placement="left"
                          headerText="Culture App Module"
                          bodyText={`Grant or remove access to the Culture App Module for all users`}
                        />
                        {isCultureApp ? "Disable" : "Enable"} Culture App Module
                      </div>
                      <div className="col-md-8 col-lg-8 enterprise-settings-value">
                        <Toggle
                          checked={isCultureApp}
                          icons={
                            true
                            // {
                            //   checked: 'Disable',
                            //   unchecked: 'Enable'
                            // }
                          }
                          className="moduleToggleSwitch"
                          onChange={() => this.enableModule("isCultureApp")}
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {this.showToggleUiForModule("isAnalytics") ? (
                    <div className="row text-left enterprise-setting-label mb-4">
                      <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                        <OoPopover
                          target="analytics-module-access"
                          placement="left"
                          headerText="Analytics Module"
                          bodyText={`Grant or remove access to the Analytics Module for all users`}
                        />
                        {isAnalytics ? "Disable" : "Enable"} Analytics Module
                      </div>
                      <div className="col-md-8 col-lg-8 enterprise-settings-value">
                        <Toggle
                          checked={isAnalytics}
                          icons={
                            true
                            // {
                            //   checked: 'Disable',
                            //   unchecked: 'Enable'
                            // }
                          }
                          className="moduleToggleSwitch"
                          onChange={() => this.enableModule("isAnalytics")}
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {this.showToggleUiForModule("isGroups") ? (
                    <div className="row text-left enterprise-setting-label mb-4">
                      <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                        <OoPopover
                          target="groups-module-access"
                          placement="left"
                          headerText="Groups Module"
                          bodyText={`Grant or remove access to the Groups Module for all users`}
                        />
                        {isGroups ? "Disable" : "Enable"} Groups Module
                      </div>
                      <div className="col-md-8 col-lg-8 enterprise-settings-value">
                        <Toggle
                          checked={isGroups}
                          icons={
                            true
                            // {
                            //   checked: 'Disable',
                            //   unchecked: 'Enable'
                            // }
                          }
                          className="moduleToggleSwitch"
                          onChange={() => this.enableModule("isGroups")}
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </span>
              ) : null}

              <div className="row text-left enterprise-setting-label mb-4">
                <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                  <OoPopover
                    target="data-import-popover"
                    placement="left"
                    headerText="Upload Data History"
                    bodyText={`See previous data imports for your workforce and recruitment analytics`}
                  />
                  OurOffice Data Import History
                </div>
                <div className="col-md-8 col-lg-8 enterprise-settings-value">
                  {organizationId && organizationId.staticHierarchy ? (
                    <div>
                      See OurOffice data import history
                      <img className="ml10" src={MappedIcon} />
                      <div
                        className="mt-1 cursor-pointer"
                        style={{ color: "#5099DE" }}
                      >
                        <span
                          onClick={() => {
                            this.props.history.push("/home/import-history");
                          }}
                        >
                          View OurOffice Data Import History
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <span style={{ color: "#F38F81" }}>
                        No data import history
                      </span>
                      <div
                        className="mt-1 cursor-pointer"
                        style={{ color: "#5099DE" }}
                      >
                        <span
                          onClick={() => {
                            this.props.history.push("/setup/org-chart");
                          }}
                        >
                          Please import your work org chart and data import
                          history
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="row text-left enterprise-setting-label mb-4">
                <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                  <OoPopover
                    target="occupation-seniority-popover"
                    placement="left"
                    headerText="Occupations and Job Categories"
                    bodyText={`Map your enterprise occupations and job categories to our standard set to allow for calculation of your KPIs, and anonymized aggregate benchmarks for each KPI.`}
                  />
                  Occupations and Job Categories
                </div>
                <div className="col-md-8 col-lg-8 enterprise-settings-value">
                  <div>
                    {this.hasExistingMapping("occupation") &&
                      this.hasExistingMapping("seniority") ? (
                      <span>
                        Occupations and Job Categories Mapped{" "}
                        <img className="ml10" src={MappedIcon} />
                      </span>
                    ) : (
                      <span style={{ color: "#F38F81" }}>
                        Occupations and Job Categories NOT Mapped{" "}
                      </span>
                    )}
                  </div>
                  <div
                    className="mt-1 cursor-pointer"
                    style={{ color: "#5099DE" }}
                  >
                    <span
                      onClick={() => {
                        this.props.history.push({
                          pathname: "/home/enterprise-info/review-existing",
                          state: {
                            seniority: existingMapping.seniority,
                            occupation: existingMapping.occupation,
                            type: "positions",
                          },
                        });
                      }}
                    >
                      Import New Occupations and Job Categories
                    </span>
                  </div>
                </div>
              </div>

              <div className="row text-left enterprise-setting-label mb-4">
                <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                  <OoPopover
                    target="gender-popover"
                    placement="left"
                    headerText="Gender Categories"
                    bodyText={`Map your gender categories to our standard categories to allow for calculation of your KPIs and anonymized aggregate benchmarks for each KPI.`}
                  />
                  Gender Categories
                </div>
                <div className="col-md-8 col-lg-8 enterprise-settings-value">
                  {this.hasExistingMapping("gender") ? (
                    <div>
                      <div>
                        Gender Categories Mapped{" "}
                        <img className="ml10" src={MappedIcon} />
                      </div>
                      <div
                        className="mt-1 cursor-pointer"
                        style={{ color: "#5099DE" }}
                      >
                        <span
                          onClick={() => {
                            this.props.history.push({
                              pathname: "/home/enterprise-info/review-existing",
                              state: {
                                gender: existingMapping.gender,
                                type: "gender",
                              },
                            });
                          }}
                        >
                          Import New Gender Categories
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <span style={{ color: "#F38F81" }}>
                        Gender Categories Mapped
                      </span>
                      <div
                        className="mt-1 cursor-pointer"
                        style={{ color: "#5099DE" }}
                      >
                        <span
                          onClick={() => {
                            this.props.history.push({
                              pathname: "/home/enterprise-info/review-existing",
                              state: {
                                gender: existingMapping.gender,
                                type: "gender",
                              },
                            });
                          }}
                        >
                          Import New Gender Categories
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="row text-left enterprise-setting-label mb-4">
                <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                  <OoPopover
                    target="ethnicity-popover"
                    placement="left"
                    headerText="Ethnicity/Race"
                    bodyText={`Map your ethnicity/race information to our standard categories to allow for calculation of your KPIs and anonymized aggregate benchmarks for each KPI.`}
                  />
                  Ethnicity/Race Categories
                </div>
                <div className="col-md-8 col-lg-8 enterprise-settings-value">
                  <div>
                    {this.hasExistingMapping("ethnicity") ? (
                      <span>
                        {" "}
                        Ethnicity/Race Mapped{" "}
                        <img className="ml10" src={MappedIcon} />
                      </span>
                    ) : (
                      <span style={{ color: "#F38F81" }}>
                        {" "}
                        Ethnicity/Race NOT Mapped{" "}
                      </span>
                    )}
                  </div>
                  <div
                    className="mt-1 cursor-pointer"
                    style={{ color: "#5099DE" }}
                  >
                    <span
                      onClick={() => {
                        this.props.history.push({
                          pathname: "/home/enterprise-info/review-existing",
                          state: {
                            ethnicity: existingMapping.ethnicity,
                            type: "ethnicity",
                          },
                        });
                      }}
                    >
                      Import New Ethnicity/Race
                    </span>
                  </div>
                </div>
              </div>

              <div className="row text-left enterprise-setting-label mb-4">
                <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                  <OoPopover
                    target="veteran-popover"
                    placement="left"
                    headerText="Veteran Status"
                    bodyText={`Map your veteran status information to our standard categories to allow for calculation of your KPIs and anonymized aggregate benchmarks for each KPI.`}
                  />
                  Veteran Status
                </div>
                <div className="col-md-8 col-lg-8 enterprise-settings-value">
                  <div>
                    {this.hasExistingMapping("veteran") ? (
                      <span>
                        {" "}
                        Veteran Status Mapped{" "}
                        <img className="ml10" src={MappedIcon} />
                      </span>
                    ) : (
                      <span style={{ color: "#F38F81" }}>
                        {" "}
                        Veteran Status NOT Mapped{" "}
                      </span>
                    )}
                  </div>
                  <div
                    className="mt-1 cursor-pointer"
                    style={{ color: "#5099DE" }}
                  >
                    <span
                      onClick={() => {
                        this.props.history.push({
                          pathname: "/home/enterprise-info/review-existing",
                          state: {
                            veteran: existingMapping.veteran,
                            type: "veteran",
                          },
                        });
                      }}
                    >
                      Import New Veteran Status
                    </span>
                  </div>
                </div>
              </div>

              <div className="row text-left enterprise-setting-label mb-4">
                <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                  <OoPopover
                    target="sexualorientation-popover"
                    placement="left"
                    headerText="Sexual Orientation"
                    bodyText={`Map your sexual orientation information to our standard categories to allow for calculation of your KPIs and anonymized aggregate benchmarks for each KPI.`}
                  />
                  Sexual Orientation
                </div>
                <div className="col-md-8 col-lg-8 enterprise-settings-value">
                  <div>
                    {this.hasExistingMapping("sexualOrientation") ? (
                      <span>
                        {" "}
                        Sexual Orientation Mapped{" "}
                        <img className="ml10" src={MappedIcon} />
                      </span>
                    ) : (
                      <span style={{ color: "#F38F81" }}>
                        {" "}
                        Sexual Orientation NOT Mapped{" "}
                      </span>
                    )}
                  </div>
                  <div
                    className="mt-1 cursor-pointer"
                    style={{ color: "#5099DE" }}
                  >
                    <span
                      onClick={() => {
                        this.props.history.push({
                          pathname: "/home/enterprise-info/review-existing",
                          state: {
                            sexualOrientation: existingMapping.sexualOrientation,
                            type: "sexualOrientation",
                          },
                        });
                      }}
                    >
                      Import New Sexual Orientation
                    </span>
                  </div>
                </div>
              </div>

              <div className="row text-left enterprise-setting-label mb-4">
                <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                  <OoPopover
                    target="religion-popover"
                    placement="left"
                    headerText="Religion"
                    bodyText={`Map your religion information to our standard categories to allow for calculation of your KPIs and anonymized aggregate benchmarks for each KPI.`}
                  />
                  Religion
                </div>
                <div className="col-md-8 col-lg-8 enterprise-settings-value">
                  <div>
                    {this.hasExistingMapping("religion") ? (
                      <span>
                        {" "}
                        Religion Mapped <img className="ml10" src={MappedIcon} />
                      </span>
                    ) : (
                      <span style={{ color: "#F38F81" }}>
                        {" "}
                        Religion NOT Mapped{" "}
                      </span>
                    )}
                  </div>
                  <div
                    className="mt-1 cursor-pointer"
                    style={{ color: "#5099DE" }}
                  >
                    <span
                      onClick={() => {
                        this.props.history.push({
                          pathname: "/home/enterprise-info/review-existing",
                          state: {
                            religion: existingMapping.religion,
                            type: "religion",
                          },
                        });
                      }}
                    >
                      Import New Religion
                    </span>
                  </div>
                </div>
              </div>

              <div className="row text-left enterprise-setting-label mb-4">
                <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                  <OoPopover
                    target="disability-popover"
                    placement="left"
                    headerText="Disability"
                    bodyText={`Map your disability information to our standard categories to allow for calculation of your KPIs and anonymized aggregate benchmarks for each KPI.`}
                  />
                  Disability
                </div>
                <div className="col-md-8 col-lg-8 enterprise-settings-value">
                  <div>
                    {this.hasExistingMapping("disability") ? (
                      <span>
                        {" "}
                        Disability Mapped{" "}
                        <img className="ml10" src={MappedIcon} />
                      </span>
                    ) : (
                      <span style={{ color: "#F38F81" }}>
                        {" "}
                        Disability NOT Mapped{" "}
                      </span>
                    )}
                  </div>
                  <div
                    className="mt-1 cursor-pointer"
                    style={{ color: "#5099DE" }}
                  >
                    <span
                      onClick={() => {
                        this.props.history.push({
                          pathname: "/home/enterprise-info/review-existing",
                          state: {
                            disability: existingMapping.disability,
                            type: "disability",
                          },
                        });
                      }}
                    >
                      Import New Disability
                    </span>
                  </div>
                </div>
              </div>

              <div className="row text-left enterprise-setting-label mb-4">
                <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                  <OoPopover
                    target="performance-popover"
                    placement="left"
                    headerText="Performance Ratings"
                    bodyText={`Map your enterprise performance ratings to our standard categories to allow for calculation of your KPIs and anonymized aggregate benchmarks for each KPI.`}
                  />
                  Performance Ratings
                </div>
                <div className="col-md-8 col-lg-8 enterprise-settings-value">
                  <div>
                    {this.hasExistingMapping("performance") ? (
                      <span>
                        Performance Ratings Mapped{" "}
                        <img className="ml10" src={MappedIcon} />
                      </span>
                    ) : (
                      <span style={{ color: "#F38F81" }}>
                        Performance Ratings NOT Mapped{" "}
                      </span>
                    )}
                  </div>
                  <div
                    className="mt-1 cursor-pointer"
                    style={{ color: "#5099DE" }}
                  >
                    <span
                      onClick={() => {
                        this.props.history.push({
                          pathname: "/home/enterprise-info/review-existing",
                          state: {
                            performance: existingMapping.performance
                              ? existingMapping.performance
                              : "",
                            type: "performance",
                          },
                        });
                      }}
                    >
                      Import New Performance Ratings
                    </span>
                  </div>
                </div>
              </div>
              <div className="row text-left enterprise-setting-label mb-4">
                <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                  <OoPopover
                    target="separation-popover"
                    placement="left"
                    headerText="Separation Mapping"
                    bodyText={`Map separations within your enterprise to a standard set of 
                  separations to allow for more detailed analytics of select KPIs.`}
                  />
                  Employee Separation
                </div>
                <div className="col-md-8 col-lg-8 enterprise-settings-value">
                  <div>
                    {this.hasExistingMapping("separation") ? (
                      <span>
                        Employee Separation Categories Mapped{" "}
                        <img className="ml10" src={MappedIcon} />
                      </span>
                    ) : (
                      <span style={{ color: "#F38F81" }}>
                        Employee Separation Categories NOT Mapped{" "}
                      </span>
                    )}
                  </div>
                  <div
                    className="mt-1 cursor-pointer"
                    style={{ color: "#5099DE" }}
                  >
                    <span
                      onClick={() => {
                        this.props.history.push({
                          pathname: "/home/enterprise-info/review-existing",
                          state: {
                            separation: existingMapping.separation,
                            type: "separation",
                          },
                        });
                      }}
                    >
                      Import New Employee Separation Mapping
                    </span>
                  </div>
                </div>
              </div>

            </div>
          }

          {
            isTrivvyUrl(organizationId) &&
            <div className="row text-left enterprise-setting-label mb-4">
              <div className="col-md-4 col-lg-4 text-right enterprise-setting-label">
                <OoPopover
                  target="separation-popover"
                  placement="left"
                  headerText="User Import History"
                  bodyText={`See a list of all CSV files imported by your organization admin.`}
                />
                User Import History
              </div>
              <div className="col-md-8 col-lg-8 enterprise-settings-value">

                <div
                  className="mt-1 cursor-pointer"
                  style={{ color: "#5099DE" }}
                >
                  <span
                    onClick={() => {
                      this.props.history.push({
                        pathname: "/home/metaData-history",

                      });
                    }}
                  >
                    See List of All CSV files Imports history
                  </span>
                </div>
              </div>
            </div>
          }




        </div >
        {/**
         * Edit Enterprise Information Modal
         */}
        < Modal isOpen={showEditEnterpriseModal} className="drill-down-modal" >
          <ModalBody>
            <div className="row mt-1">
              <div className="offset-md-1 offset-lg-1 pick-office-modal-body-title">
                Edit Enterprise Information
              </div>
            </div>
            <div className="container mt30">
              <div className="row mb30">
                <div className="col-md-4 col-lg-4 text-right pick-office-col-title pt0">
                  {/* <OoPopover
                    target="modal-popover"
                    placement='left'
                    headerText="Enterprise Name"
                    bodyText={`Your enterprise name is set when the enterprise account is created, and can't be changed. In case of questions or to request a change, please contact team@ouroffice.io.`}
                  /> */}
                  Enterprise Name
                </div>
                <div className="col-md-6 col-lg-6">
                  <Input value={enterpriseName} onChange={this.handleEnterpriseNameChange} />
                </div>
              </div>
              <div className="row">
                <div className="col-md-4 col-lg-4 text-right pick-office-col-title pt0">
                  Enterprise Industry
                </div>
                <div className="col-md-6 col-lg-6">
                  <Select
                    simpleValue
                    value={
                      industryId ? industryId : industry ? industry._id : null
                    }
                    options={
                      industriesList
                        ? industriesList.map((i) => ({
                          value: i._id,
                          label: i.name,
                        }))
                        : []
                    }
                    onChange={this.handleIndustryChange}
                    clearable={false}
                  />
                </div>
              </div>
              <div className="row mt30 mb20">
                <div className="col-md-4 col-lg-4"></div>
                <div className="col-md-6 col-lg-6">
                  <div className="row">
                    <div className="col-lg-7 col-md-7">
                      <Button
                        className="profile-modal-save-btn"
                        onClick={this.handleIndustrySave}
                      >
                        <span className="profile-modal-save-btn-txt">
                          Save
                          <span className="ml10 flaticon-tick"></span>
                        </span>
                      </Button>
                    </div>
                    <div className="col-lg-5 col-md-5">
                      <Button
                        className="profile-modal-cancel-btn"
                        onClick={this.toggleEditEnterpriseModal}
                      >
                        <span className="profile-modal-cancel-btn-txt">
                          Cancel
                        </span>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <SmsRoutingModal
          isOpen={this.state.showSmsRoutingModal}
          toggle={() =>
            this.setState({
              showSmsRoutingModal: !this.state.showSmsRoutingModal,
            })
          }
          onSave={(data) => {
            this.setState({
              smsRoutingConfigured: true,
              showSmsRoutingModal: false,
              smsPhoneNumber: (data && data.phoneNumber) || this.state.smsPhoneNumber,
              smsFirstName: (data && data.firstName) || this.state.smsFirstName,
              smsLastName: (data && data.lastName) || this.state.smsLastName
            });
          }}
          user={this.props.user}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    orgEmail: state.user.profile.organizationId.emailDomains,
    // user:state.user
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EnterpriseSettings);
